import mapToObject from '../util/map-to-object';

const SOVProperties = [
  'AuctionWonPercent',
  'AuctionLostToBudgetPercent',
  'AuctionLostToRankPercent',
  'AuctionLostToAdQualityPercent',
  'AuctionLostToLandingPercent',
  'AuctionLostToBidPercent',
  'ClickSharePercent',
];

export default mapToObject(SOVProperties, property => `PerformanceMetrics/${property}`);
